import * as React from 'react';

import { useSelector } from 'react-redux';
import { BuilderLayout, BuilderLogo } from '../../components/DeveloperInfo';
import { firstBuilderSelector } from '../../selectors';
import { PremiumBuilderLabel, PremiumBuilderLayout, PremiumBuilderLogo } from '../../components/PremiumBuilderInfo';

export const BuilderInfo: React.FC = () => {
  const { logoUrl, name, profileUrl, stats, yearOfFoundation, isPremium, isReliable } =
    useSelector(firstBuilderSelector);

  if (isPremium) {
    return (
      <PremiumBuilderLayout
        logo={<PremiumBuilderLogo logoUrl={logoUrl} builderName={name} url={profileUrl} />}
        label={isReliable ? <PremiumBuilderLabel /> : null}
        yearOfFoundation={yearOfFoundation}
        stats={stats}
      />
    );
  }

  return (
    <BuilderLayout
      logo={<BuilderLogo logoUrl={logoUrl} developerName={name} url={profileUrl} />}
      stats={stats}
      yearOfFoundation={yearOfFoundation}
    />
  );
};
